import React from "react";

import { Content } from "src/components/AddPoshmarkExtensionDialog";

import type Step from "../Step";

interface MercariAddExtensionProps {
  onClose: () => void;
  onStepChange: (step: Step) => void;
  update?: boolean;
}

function MercariAddExtension({
  onClose,
  onStepChange,
  update,
}: MercariAddExtensionProps) {
  return <Content platform="Mercari" update={update} onClose={onClose} />;
}

export default MercariAddExtension;
